export default __webpack_public_path__ + "static/media/image.earth-unleashed.c8a15e0d.png";